import React from "react";
import ReactDOM from "react-dom";
import ImageUploader from "react-images-upload";
import axios from 'axios';



class Defaul extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      pictures: [],
      files: [],
      email:'',
      id: '',
      note: ''

    };
    this.onDrop = this.onDrop.bind(this);
    this.onClickHandler = this.onClickHandler.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  onDrop(pictureFiles, pictureDataURLs) {
    this.setState({
      files: this.state.files.concat(pictureFiles)
    });
    console.log(pictureFiles)
  }
  
  onChange=(event)=>{
    this.setState({ [event.target.name]: event.target.value })
  }

  onClickHandler(event){
    event.preventDefault();
    const data = new FormData()
    data.append('id', this.state.id)
    data.append('note', this.state.note)
    data.append('email', this.state.email)
    data.append('files', this.state.files)
       console.log(data)
         axios.post("https://apis.pixelbyhand.com/images/api", data)
         .then(res=>{
           console.log(res.data)
         })
       
       
    
  }

  render() {
    return (
      <div className="App">
        <h1>React Images Upload Demo</h1>

        <form onSubmit={this.onClickHandler} className="uploadform">


        

        
          <div style={{ marginRight: "15px" }}>
            <ImageUploader
              withIcon={false}
              value={this.state.files}
              withPreview={true}
              label="files"
              buttonText="Upload Images"
              onChange={this.onDrop}
              imgExtension={[".jpg", ".gif", ".png", ".gif", ".svg"]}
              maxFileSize={1048576}
              fileSizeError=" file size is too big"
            />
          </div>

            
          <div className="emailinput col-md-12">
               <label hidden htmlFor="id">ID</label>
                    <input
                     
                      type=""
                      name="id"
                      required
                      onChange={this.onChange}
                      value={this.state.id}
                      
                    />
                  </div>

              

               <div className="emailinput col-md-12">
               <label  htmlFor="email">WHAT'S YOUR E-MAIL ADDRESS?</label>
                    <input
                      type="email"
                      required
                      name="email"
                      required
                      value={this.state.email}
                      onChange={this.onChange}
                    />
                  </div>
                  
                  
                  <div className="note col-md-12">
                  <label  htmlFor="note">FEEL FREE TO ADD ANY INSTRUCTIONS YOU MAY HAVE</label>
                    <textarea
                      required
                      name="note" 
                      value={this.state.note}
                      onChange={this.onChange}
                    />
                  </div>

            <div className="form-group not-wide"> 
                  <input type="submit" className="btn btn-danger btn-block button2" value="Upload Images" />
            </div> 


            </form>
          
        </div>
     
    );
  }
}


export default Defaul;

